import { Button, Input } from "antd";
import { StyleSheet } from "../../../StyleSheet";
import { MinusOutlined, PlusOutlined } from "@ant-design/icons";

interface QuantitySelectorProps {
    quantity: string;
    setQuantity: (value: string) => void;
    max: number;
}

const QuantitySelector = (props: QuantitySelectorProps) => {
    const { quantity, setQuantity, max } = props;
    const MIN_SELECTED_QUANTITY = 1;
    const currentQuantity = parseInt(quantity, 10) || 0;

    const increment = () => {
        const newValue = currentQuantity + 1;
        if (newValue <= max) {
            setQuantity(String(newValue === 0 ? 1 : newValue));
        }
    };

    const decrement = () => {
        if (currentQuantity > MIN_SELECTED_QUANTITY) {
            const newValue = currentQuantity - 1;
            setQuantity(String(newValue));
        }
    };

    const isDecrementDisabled = currentQuantity <= MIN_SELECTED_QUANTITY;
    const isIncrementDisabled = currentQuantity >= max;

    const getIconStyle = (isDisabled: boolean) => ({
        ...stylesQuantity.buttonIcon,
        color: isDisabled ? stylesQuantity.buttonTextDisabled.color : stylesQuantity.buttonTextActive.color,
    });

    return (
        <div style={stylesQuantity.container}>
            <Button
                type="text"
                onClick={decrement}
                disabled={isDecrementDisabled}
                style={stylesQuantity.button}
                icon={<MinusOutlined style={getIconStyle(isDecrementDisabled)} />}
            />
            <div style={stylesQuantity.inputWrapper}>
                <Input
                    bordered={false}
                    value={quantity === "" ? "0" : quantity}
                    readOnly={true}
                    style={stylesQuantity.inputText}
                />
            </div>
            <Button
                type="text"
                onClick={increment}
                disabled={isIncrementDisabled}
                style={stylesQuantity.button}
                icon={<PlusOutlined style={getIconStyle(isIncrementDisabled)} />}
            />
        </div>
    );
};

const stylesQuantity = StyleSheet.create({
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        height: 35,
        alignSelf: 'center',
        marginTop: 12,
        marginBottom: 20,
        border: '1px solid #0055c2',
        borderRadius: 10,
        backgroundColor: '#e3f0f9',
        overflow: 'hidden',
        margin: 0
    },
    button: {
        width: 42,
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: 'none',
        boxShadow: 'none',
        padding: 0,
        backgroundColor: 'transparent',
    },
    buttonIcon: {
        fontSize: 20,
        fontWeight: 'bold',
    },
    buttonTextActive: {
        color: '#0055c2',
    },
    buttonTextDisabled: {
        color: 'gray',
    },
    inputWrapper: {
        flex: 1,
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    inputText: {
        width: '100%',
        height: '100%',
        textAlign: 'center',
        fontSize: 18,
        color: 'black',
        border: 'none',
        boxShadow: 'none',
        backgroundColor: 'transparent',
        padding: 0,
        lineHeight: '40px',
    },
});

export default QuantitySelector;